<template>
	<div class="case-mask">
		<div class="case-close" @click="$emit('close')">&times;</div>
		<div class="case-scroll">

			<!-- Hero -->
			<header class="hero">
				<span class="hero-tag">火锅产业大脑 · INDUSTRY BRAIN</span>
				<h1>火锅产业数字化转型案例集</h1>
				<p>从供应链到门店后厨，从消费者画像到共享工厂，4个真实落地场景展示火锅产业大脑如何用数据重构经营效率。</p>
				<div class="hero-stats">
					<div class="hero-stat" v-for="stat in heroStats" :key="stat.label">
						<div class="num">{{ stat.num }}</div>
						<div class="label">{{ stat.label }}</div>
					</div>
				</div>
			</header>

			<!-- 案例列表 -->
			<main class="cases">
				<section class="case" v-for="item in cases" :key="item.num">
					<div class="case-img">
						<img :src="item.img" :alt="item.alt" />
					</div>
					<div class="case-info">
						<span class="case-num">{{ item.num }}</span>
						<h2>{{ item.title }}</h2>
						<p class="pain">{{ item.pain }}</p>
						<p class="solution">{{ item.solution }}</p>
						<div class="case-metrics">
							<div class="metric" v-for="(m, i) in item.metrics" :key="i">
								<div class="v">{{ m.v }}</div>
								<div class="k">{{ m.k }}</div>
							</div>
						</div>
					</div>
				</section>
			</main>

			<footer class="footer">
				火锅产业大脑 · 数据价值化应用案例 &nbsp;|&nbsp; 数据为试点区域测算值，仅供参考
			</footer>

		</div>
	</div>
</template>

<script>
	export default {
		name: 'szhzxCase',
		data() {
			return {
				heroStats: [
					{ num: '4', label: '核心应用场景' },
					{ num: '30%+', label: '综合成本下降' },
					{ num: '500+', label: '接入门店与企业' },
					{ num: '2.8亿', label: '日均处理数据量' }
				],
				cases: [
					{
						num: 'CASE 01',
						title: '智慧供应链 · 食材溯源与智能补货',
						img: 'https://media.doubao.com/space/api/box/stream/download/all_by_mount_point/JUJbb9GBkoMHUQxzFoBc11ounlc',
						alt: '智慧供应链冷链仓库',
						pain: '痛点：毛肚、鸭肠等生鲜损耗高，人工盘点误差大，溯源链条断在田头到门店之间。',
						solution: '产业大脑接入上游基地、冷链物流与门店POS数据，建立一物一码溯源体系；基于历史销量、天气、节假日自动生成补货建议，冷链温湿度异常实时预警。',
						metrics: [
							{ v: '-28%', k: '生鲜损耗率' },
							{ v: '-35%', k: '库存周转天数' },
							{ v: '100%', k: '溯源覆盖率' }
						]
					},
					{
						num: 'CASE 02',
						title: '智能门店 · AI后厨与动态排班',
						img: 'https://media.doubao.com/space/api/box/stream/download/all_by_mount_point/GqS7bYr6BovJJ0xAyTZc48fwnhc',
						alt: '智能门店后厨',
						pain: '痛点：晚高峰出餐慢、人效波动大，厨师依赖经验，排班靠店长拍脑袋。',
						solution: '后厨关键工序上智能终端与炒菜机器人，产业大脑根据实时订单流预测出餐节奏；结合历史客流、节假日、员工技能矩阵自动生成排班表，人岗精准匹配。',
						metrics: [
							{ v: '-22%', k: '平均出餐时长' },
							{ v: '+18%', k: '人效坪效提升' },
							{ v: '-15%', k: '人工成本占比' }
						]
					},
					{
						num: 'CASE 03',
						title: '数据营销 · 消费者画像与精准复购',
						img: 'https://media.doubao.com/space/api/box/stream/download/all_by_mount_point/UuXibOAnGoNswhx3jS7col8gnbF',
						alt: '消费者数据大屏',
						pain: '痛点：会员沉睡、营销发券凭感觉，新客拉新成本高，老客复购找不到抓手。',
						solution: '打通堂食POS、外卖、小程序、点评评论数据，构建消费者标签画像；产业大脑识别高价值客群与流失预警客群，自动推送个性化套餐、券包与生日权益，营销动作可归因。',
						metrics: [
							{ v: '+42%', k: '会员复购率' },
							{ v: '-30%', k: '营销获客成本' },
							{ v: '3.6倍', k: '券核销 ROI' }
						]
					},
					{
						num: 'CASE 04',
						title: '产业协同 · 底料共享工厂与产能调度',
						img: 'https://media.doubao.com/space/api/box/stream/download/all_by_mount_point/EI54bOWntoG5rLx92lPcgXhLnbb',
						alt: '共享工厂数字孪生',
						pain: '痛点：中小品牌自建底料厂投入大、产能闲置，头部品牌旺季产能不足，品质与成本两头难。',
						solution: '产业大脑搭建底料共享工厂数字孪生平台，对接上下游订单池，按工艺、产能、能耗最优自动排产；原料集中采购、配方云端下发、批次质量全程可追溯，多家品牌共享一条产线。',
						metrics: [
							{ v: '+45%', k: '产线利用率' },
							{ v: '-20%', k: '底料综合成本' },
							{ v: '120+', k: '共享品牌数' }
						]
					}
				]
			}
		}
	}
</script>

<style scoped lang="scss">
	/* 数字化转型案例集：全屏弹出页 */
	.case-mask {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		background: #0d1117;
		z-index: 10000;
	}

	.case-close {
		position: fixed;
		top: 16px;
		right: 28px;
		z-index: 10001;
		font-size: 40px;
		line-height: 1;
		color: #9ca3af;
		cursor: pointer;
		transition: color .2s;
	}

	.case-close:hover {
		color: #fff;
	}

	.case-scroll {
		height: 100%;
		overflow-y: auto;
		color: #e5e7eb;
		line-height: 1.7;
		font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
	}

	/* ===== Hero ===== */
	.hero {
		position: relative;
		padding: 80px 24px 60px;
		text-align: center;
		background:
			radial-gradient(ellipse at 20% 0%, rgba(232, 93, 47, 0.18), transparent 55%),
			radial-gradient(ellipse at 80% 100%, rgba(59, 130, 246, 0.15), transparent 55%),
			#0d1117;
		border-bottom: 1px solid rgba(255, 255, 255, 0.06);
	}

	.hero-tag {
		display: inline-block;
		padding: 6px 16px;
		border: 1px solid rgba(232, 93, 47, 0.5);
		border-radius: 999px;
		color: #ff8a5c;
		font-size: 13px;
		letter-spacing: 2px;
		margin-bottom: 24px;
	}

	.hero h1 {
		font-size: clamp(30px, 5vw, 52px);
		font-weight: 900;
		letter-spacing: 2px;
		margin-bottom: 18px;
		background: linear-gradient(135deg, #fff 30%, #ff8a5c 100%);
		-webkit-background-clip: text;
		background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.hero p {
		max-width: 640px;
		margin: 0 auto;
		color: #9ca3af;
		font-size: 16px;
	}

	.hero-stats {
		display: flex;
		justify-content: center;
		gap: 48px;
		margin-top: 44px;
		flex-wrap: wrap;
	}

	.hero-stat .num {
		font-size: 32px;
		font-weight: 900;
		color: #ff6b35;
	}

	.hero-stat .label {
		font-size: 13px;
		color: #6b7280;
		margin-top: 4px;
	}

	/* ===== 案例容器 ===== */
	.cases {
		max-width: 1200px;
		margin: 0 auto;
		padding: 60px 24px;
	}

	.case {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 48px;
		align-items: center;
		padding: 48px 0;
		border-bottom: 1px solid rgba(255, 255, 255, 0.06);
	}

	.case:last-child {
		border-bottom: none;
	}

	.case:nth-child(even) .case-img {
		order: 2;
	}

	.case-img {
		position: relative;
		border-radius: 12px;
		overflow: hidden;
		aspect-ratio: 16/10;
		box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
	}

	.case-img img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		display: block;
	}

	.case-img::after {
		content: '';
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		background: linear-gradient(180deg, transparent 60%, rgba(13, 17, 23, 0.6));
		pointer-events: none;
	}

	.case-num {
		display: inline-block;
		font-size: 14px;
		font-weight: 700;
		color: #ff6b35;
		letter-spacing: 3px;
		margin-bottom: 12px;
	}

	.case h2 {
		font-size: clamp(22px, 3vw, 30px);
		font-weight: 700;
		margin-bottom: 16px;
		color: #fff;
	}

	.case .pain {
		color: #9ca3af;
		font-size: 14px;
		margin-bottom: 14px;
		padding-left: 12px;
		border-left: 3px solid #e85d2f;
	}

	.case .solution {
		color: #d1d5db;
		font-size: 15px;
		margin-bottom: 20px;
	}

	.case-metrics {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 12px;
	}

	.metric {
		background: rgba(255, 255, 255, 0.03);
		border: 1px solid rgba(255, 255, 255, 0.08);
		border-radius: 8px;
		padding: 14px 12px;
		text-align: center;
	}

	.metric .v {
		font-size: 22px;
		font-weight: 900;
		color: #ff8a5c;
	}

	.metric .k {
		font-size: 12px;
		color: #6b7280;
		margin-top: 4px;
	}

	/* ===== 底部 ===== */
	.footer {
		text-align: center;
		padding: 48px 24px;
		background: #0a0d12;
		color: #6b7280;
		font-size: 13px;
		border-top: 1px solid rgba(255, 255, 255, 0.06);
	}

	@media (max-width: 768px) {
		.hero { padding: 56px 20px 40px; }
		.hero-stats { gap: 28px; }
		.case {
			grid-template-columns: 1fr;
			gap: 24px;
			padding: 36px 0;
		}
		.case:nth-child(even) .case-img { order: 0; }
		.case-metrics { grid-template-columns: repeat(3, 1fr); gap: 8px; }
		.metric .v { font-size: 18px; }
	}
</style>
